import { render, staticRenderFns } from "./FormField.vue?vue&type=template&id=6487b1e8&scoped=true&"
import script from "./FormField.vue?vue&type=script&lang=js&"
export * from "./FormField.vue?vue&type=script&lang=js&"
import style0 from "./FormField.vue?vue&type=style&index=0&id=6487b1e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6487b1e8",
  null
  
)

export default component.exports